import type { NPCConfig } from '@/entities';
import v2Day1SharedNPCs from "@/config/NPCConfigs/v2/V2Day1SharedNPCs.ts";
// import {StoryManager} from "@/systems";

const config: NPCConfig[] = [
  ...v2Day1SharedNPCs,
  {
    x: 2150,
    y: 1450,
    name: 'Bunga',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    repeatable: true, // Day Keeper should have repeatable dialogs
    dialogTree: {
      startDialogId: 'bunga_part2_1',
      nodes: {
        bunga_part2_1: {
          id: 'bunga_part2_1',
          speaker: 'Bunga',
          text: `Aku akan mencari Diana, selagi itu sebaiknya kamu menyiapkan sesuatu untuk Diana!`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga_day1_2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 3920,
    y: 900,
    name: 'Diana',
    spriteImage: 'assets/sprite/sprite_diana.png', // Use NPC image
    dialogTree: {
      startDialogId: 'cutscene_1',
      nodes: {
        cutscene_1: {
          id: 'diana1',
          speaker: 'Diana',
          text: `Sudah lama aku tidak kesini`,
          backgroundImage: '/assets/cutscene/diana_pray.png',
          nextDialogId : "cutscene_2",
        },
        cutscene_2: {
          id: 'diana1',
          speaker: 'Diana',
          text: `Hari ini aku berulang tahun yang ke 17.`,
          backgroundImage: '/assets/cutscene/diana_pray.png',
          nextDialogId : "cutscene_3",
        },
        cutscene_3: {
          id: 'diana1',
          speaker: 'Diana',
          text: `Walaupun ibu mati saat kecil, aku tetap sangan rindu.`,
          backgroundImage: '/assets/cutscene/diana_pray.png',
          nextDialogId : "cutscene_4",
        },
        cutscene_4: {
          id: 'diana1',
          speaker: 'Diana',
          text: `Semoga ibu merasa kedamaian.`,
          backgroundImage: '/assets/cutscene/diana_pray.png',
          nextDialogId : "diana1",
        },
        diana1: {
          id: 'diana1',
          speaker: 'Diana',
          characterImage: '/assets/character/v2/diana.png',
          text: `Selamat pagi kak. Aku baru saja mengunjungi Ibu.`,
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId : "diana2",
        },
        diana2: {
          id: 'diana2',
          text : "",
          speaker: '',
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId : "kuburan2",
          choices: [
            {
              text: 'Aku juga ingin mengunjungi makam ibu.',
              nextDialogId : "diana3a",
            },
            {
              text: 'Ide bagus, aku juga disini untuk mencari ibu.',
              nextDialogId : "diana3a",
            },
          ],
        },
        diana3a: {
          id: 'diana3a',
          speaker: 'Diana',
          backgroundImage: '/assets/cutscene/black.png',
          characterImage: '/assets/character/v2/diana.png',
          text: `Aku akan berikan kak Yan waktu sendiri dengan ibu..`,
          nextDialogId : "diana4a",
        },
        diana4a: {
          id: 'diana4a',
          speaker: 'Diana',
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/cutscene/black.png',
          text: `Ngomong-ngomong, apakah kak Yan melihat Elsa?`,
          nextDialogId : "diana5",
        },
        diana5: {
          id: 'diana5',
          text : "",
          speaker: '',
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/cutscene/black.png',
          choices: [
            {
              text: 'Oh, aku kira Elsa bersama kamu?',
              nextDialogId : "diana6",
            },
            {
              text: 'Tidak, pagi-pagi sudah tidak ada Elsa di kamar.',
              nextDialogId : "diana6",
            },
          ],
        },
        diana6: {
          id: 'diana4a',
          speaker: 'Diana',
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/cutscene/black.png',
          text: `Tidak, aku belum melihat Elsa dari pagi. Mungkin dia tersesat di Danau.`,
          nextDialogId : "diana7",
        },
        diana7: {
          id: 'diana4a',
          speaker: 'Diana',
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/cutscene/black.png',
          text: `Kalau begitu aku akan ke Danau mencari Elsa.`,
          nextDialogId : "diana8",
        },
        diana8: {
          id: 'diana8',
          text : "",
          speaker: '',
          backgroundImage: '/assets/cutscene/black.png',
          characterImage: '/assets/character/v2/diana.png',
          choices: [
            {
              text: 'Baiklah, hati-hati ya.',
              nextDialogId : "diana6",
              storyAction: { type: 'nextDay', value: 0 },
              isEnd : true
            },
            {
              text: 'Ok, sampai jumpa!',
              nextDialogId : "diana6",
              storyAction: { type: 'nextDay', value: 0 },
              isEnd : true
            },
          ],
        },
      },
    },
  },
  {
    x: 4590,
    y: 1950,
    name: '',
    scale : 1.25,
    spriteImage: 'assets/sprite/sprite_pancingan.png', // Use NPC image
    repeatable : false,
    interactOnce : true,
    dialogTree: {
      startDialogId: 'fishing_1',
      nodes: {
        fishing_1: {
          id: 'fishing_1',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Ada Umpan dan Pancingan`,
          nextDialogId : "fishing_2",
        },
        fishing_2: {
          id: 'fishing_2',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Seberapa jauh harus melempar umpan?`,
          nextDialogId : "fishing_3",
        },
        fishing_3: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: ``,
          choices: [
            {
              text: 'Lempar umpan jarak dekat',
              nextDialogId: 'fishing_a1',
              itemReward: { itemId: 'fish', quantity: 1},
            },
            {
              text: 'Lempar umpan jarak sedang',
              nextDialogId: 'fishing_b1',
              itemReward: { itemId: 'liontin', quantity: 1},
            },
            {
              text: 'Lempar umpan jarak jauh',
              nextDialogId: 'fishing_c1',
              itemReward: { itemId: 'sendal', quantity: 1},
            },
          ],
        },
        fishing_ending: {
          id: 'fishing_2',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Pancingan sudah tidak bisa dipakai`,
          isEnd : true,
        },

        fishing_a1: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_a2",
          sfx : "fishingReel"
        },
        fishing_a2: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_a3",
          sfx : "fishingReel"
        },
        fishing_a3: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Yan Mendapatkan Ikan!`,
          nextDialogId : "fishing_ending",
        },

        fishing_b1: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_b2",
          sfx : "fishingReel"
        },
        fishing_b2: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_b3",
          sfx : "fishingReel"
        },
        fishing_b3: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Yan Mendapatkan Liontin!`,
          nextDialogId : "fishing_b4",
        },
        fishing_b4: {
          id: 'fishing_2',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Liontin ini bisa menjadi kado untuk Diana.`,
          nextDialogId : "fishing_ending",
        },
        fishing_c1: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_c2",
          sfx : "fishingReel"
        },
        fishing_c2: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_c3",
          sfx : "fishingReel"
        },
        fishing_c3: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Yan Mendapatkan Sendal!`,
          nextDialogId : "fishing_ending",
        },
      },
    },
  },
];

export default config;
